// import { debounce } from 'lodash'

import { ActionTypes as SessionActionTypes } from '../reducers/Session'

export const fetchUser = () =>
  // debounce(
  async (dispatch, getState, api) => {
    try{
      const response = await api.fetchUser()

      if (!response.connected) {
        dispatch({
          type: SessionActionTypes.CREATE_FORM,
          ...response
        })
      } else {
        const challenge = await api.fetchChallenge()

        if (challenge) {
          dispatch({
            type: SessionActionTypes.INIT_SESSION,
            initAt: performance.now(),
            ...response,
            challenge: {
              current: challenge.rank,
              total: challenge.count,
              best: challenge.bestRanking,
              quizz: challenge.quizTaken,
              quizzTotal: challenge.totalQuiz,
              results: challenge.results,
              rankingIQ: challenge.score,
            },
          })
        }
      }
      
    } catch (err){
      console.log(err)
    }
  }

export const logIn = fields => async (dispatch, getState, api) => {
  const response = await api.logIn(getState().Session.action, fields)

  if (!response.connected) {
    dispatch({
      type: SessionActionTypes.HANDLE_ERRORS,
      ...response
    })
  } else {
    const challenge = await api.fetchChallenge()

    dispatch({
      type: SessionActionTypes.INIT_SESSION,
      initAt: performance.now(),
      ...response,
      challenge: {
        current: challenge.rank,
        total: challenge.count,
        best: challenge.bestRanking,
        quizz: challenge.quizTaken,
        quizzTotal: challenge.totalQuiz,
        results: challenge.results,
        rankingIQ: challenge.score,
      },
    })
  }
}

export const changePassword = fields => async (dispatch, getState, api) => {
  const response = await api.changePassword(
    getState().Session.forgotForm.action,
    fields
  )

  if (!response.success) {
    dispatch({
      type: SessionActionTypes.HANDLE_ERRORS,
      error: {
        changePassword: response.error
      }
    })
  } else {
    dispatch({
      type: SessionActionTypes.PASSWORD_CHANGED
    })
  }
}

export const editPassword = (fields,action) => async (dispatch, getState, api) => {
  const response = await api.changePassword(
    action,
    fields
  )

  if (!response.success) {
    dispatch({
      type: SessionActionTypes.HANDLE_ERRORS,
      error: {
        changePassword: response.error
      }
    })
  } else {
    dispatch({
      type: SessionActionTypes.PASSWORD_CHANGED
    })
  }
}

export const editChallenge = () => async (dispatch, getState, api) => {
  const challenge = await api.fetchChallenge()
  dispatch({
    type: SessionActionTypes.EDIT_CHALLENGE,
    challenge: {
      current: challenge.rank,
      total: challenge.count,
      best: challenge.bestRanking,
      quizz: challenge.quizTaken,
      quizzTotal: challenge.totalQuiz,
      results: challenge.results,
      rankingIQ: challenge.score,
    },
  })
}

export const logOut = () => async (dispatch, getState, api) => {
  await api.logOut()

  dispatch({
    type: SessionActionTypes.CLEAR_SESSION
  })

  window.location = '/'
}

export const updateProfilePicture = (file) => async(dispatch, getState, api) => {
  dispatch({
    type: SessionActionTypes.EDIT_PICTURE,
    picture: file,
  })
}


export const forgotPassword = fields => async (dispatch, getState, api) => {
  const response = await api.forgotPassword(getState().Session.forgot_password.action, fields)
  if (!response.success) {
    dispatch({
      type: SessionActionTypes.HANDLE_ERRORS,
      error: {
        message: response.error
      }
    })
  }else{
    dispatch({
      type: SessionActionTypes.HANDLE_ERRORS,
      error: {
        success: "You will receive an email with a link to reset your password"
      }
    })
  }
}

export const checkConnect = () => async (dispatch, getState, api) => {
  const response = await api.fetchUser()
  if (!response.connected && getState().Session.initAt !== -1) {
    await api.logOut()

    dispatch({
      type: SessionActionTypes.CLEAR_SESSION
    })
  
    window.location = '/'
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/Session.js